
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import {  FieldSubmissionValueInterface, FieldSubmissionValidity } from '@core/custom-forms/models/submissions/submissions-custom-form-field-data.model';

import { CustomFormFieldSubmission, FieldDynamicUrlLinkButtonProjectContext } from '@core/objects/form';

@Component({
    selector: 'form-field-fill-dynamic-url-link-button-v1',
    templateUrl: './fill-dynamic-url-link-button-v1.component.html'
})
export class FillDynamicUrlLinkButtonV1FieldComponent implements OnInit {
    private readonly PROJECT_PATTERN = '{PROJECTID}';
    private readonly FORM_PATTERN = '{FORMID}';

    @Input() fieldSubmission: CustomFormFieldSubmission;
    @Input() dynamicLinKButtoncontext: FieldDynamicUrlLinkButtonProjectContext;
    @Output() fieldValueChange = new EventEmitter<FieldSubmissionValueInterface>();
    @Output() fieldValidityChange = new EventEmitter<FieldSubmissionValidity>();


    public link: string = ''
    ngOnInit(): void {

        // Set the link value only if the provided field value is not an empty string and context is set
        if (this.dynamicLinKButtoncontext && this.fieldSubmission.field?.options?.url && this.dynamicLinKButtoncontext.project && this.dynamicLinKButtoncontext.form){
            this.link = this.fieldSubmission.field.options.url
                .replace(
                    this.PROJECT_PATTERN,this.dynamicLinKButtoncontext.project)
                .replace(
                    this.FORM_PATTERN, this.dynamicLinKButtoncontext.form)
        }
    }

    goToUrl() {
        
        window.open(this.link, '_blank');
    }

}
